import { render, staticRenderFns } from "./OverviewPaymentTransaction.vue?vue&type=template&id=4f601ef8&"
import script from "./OverviewPaymentTransaction.vue?vue&type=script&lang=js&"
export * from "./OverviewPaymentTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports